export const travelRequestHeaders = [
  'Request No',
  'Date',
  'Destination',
  'Purpose',
  'Status',
];
